import React, { Component } from 'react';
import VerticalLayout from "../../components/VerticalLayout/";
import LocationDetailPage from './LocationDetailPage';

class LocationDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }        
    }

    componentDidCatch(){
        
        localStorage.getItem("authUser")?this.props.history.push('/locations'):this.props.history.push('/404')
    }


    render() {
        
        let obj = JSON.parse(localStorage.getItem("authUser"))

        return (
                obj?
                <VerticalLayout>
                    <LocationDetailPage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                    />

                </VerticalLayout>

                :

                <LocationDetailPage 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    obj = {obj}
                />
          
        );
    }
}

export default LocationDetail;
